// Your web app's Firebase configuration
import { onFirebaseInit } from "../fb";
import { onConsentChange, startConsentTracking } from "../consent";
import { isLocalMode } from "../localStore";
import { setAnalyticsConsent } from "../analytics";
import { isDiscordBuild } from "../portal";
import { patchDiscordUrls } from "../discord";

var firebaseConfig = {
    apiKey: "AIzaSyCsOAfG-hkCT-pyWbQkdDqCHZGy5L0v67U",
    authDomain: "rafiki-d956b.firebaseapp.com",
    databaseURL: "https://rafiki-d956b.firebaseio.com",
    projectId: "rafiki-d956b",
    storageBucket: "rafiki-d956b.appspot.com",
    messagingSenderId: "201918875792",
    appId: "1:201918875792:web:e815c462ac93a9a1a6b015",
    measurementId: "G-M4QXLLT7S6"
};
// iPhone Safari breaks if two auth persistence changes overlap ("The database connection is
// closing"). Every change goes through this queue, one at a time, and a failure is ignored:
// the player just stays signed in for this visit only.
let persistenceQueue: Promise<void> = Promise.resolve();
let persistenceUpgraded = false;
export const setAuthPersistence = (persistence: string): Promise<void> => {
    // Sign-in is kept with Firebase's default storage. Switching storage type at runtime
    // reopens the browser database, which iPhones handle badly, so requests to switch are
    // ignored. Staying signed in is strictly necessary for the game and needs no consent.
    return persistenceQueue;
};

// Retries an action that hit a temporary browser storage error (seen on iPhones).
export const withStorageRetry = async <T>(fn: () => Promise<T>, tries = 3): Promise<T> => {
    for (let i = 1; ; i++) {
        try {
            return await fn();
        } catch (e) {
            const msg = String((e as any)?.message || e);
            if (i >= tries || !/IDB|IndexedDB|database connection|transaction/i.test(msg)) throw e;
            await persistenceQueue;
            await new Promise((r) => setTimeout(r, 400 * i));
        }
    }
};

export const initializeFirebase = () => {
    // Inside Discord every request must go through Discord's proxy, before Firebase makes any.
    if (isDiscordBuild) patchDiscordUrls();
    // Firebase itself arrives after the start screen (see fb.ts); this runs as soon as it does,
    // before anything else can use it.
    onFirebaseInit((fb) => {
        fb.initializeApp(firebaseConfig);
        // Local mode: the app object exists (some components create a Firestore handle while
        // rendering) but nothing is ever read, written or reported, so no connection is made.
        if (isLocalMode) return;
        // Discord's proxy doesn't stream, so Firestore polls instead.
        if (isDiscordBuild) fb.firestore().settings({ experimentalForceLongPolling: true });
        // fb.functions().useFunctionsEmulator("http://localhost:5001");
        // A test build against the Firestore emulator (and the rules in firestore.rules):
        // REACT_APP_FIRESTORE_EMULATOR=localhost:8085. Never set for a real build.
        const emulator = process.env.REACT_APP_FIRESTORE_EMULATOR;
        if (emulator) fb.firestore().settings({ host: emulator, ssl: false, experimentalForceLongPolling: true });
    });
    if (isLocalMode) return;
    // Analytics starts only once the visitor has consented, and stays off after a refusal
    // (see analytics.ts): before that Google's script isn't even downloaded.
    onConsentChange((granted) => {
        setAnalyticsConsent(granted);
        // Only switch once: Google's consent tool can report consent several times per visit,
        // and each switch reopens the browser database.
        if (granted && !persistenceUpgraded) {
            persistenceUpgraded = true;
            setAuthPersistence("local"); // firebase.auth.Auth.Persistence.LOCAL
        }
    });
    startConsentTracking();
};
